import { BaseInfo, BaseItem, Button } from "zhihao-ui-react";
import type { ReactNode } from "react";
import { fileService } from "@/api/fileService";

/** 旧 ZhGrid 的兼容入口；渲染能力直接交给 zhihao-ui-react BaseInfo。 */
export function ZhGrid({
    children,
    cols = 4,
    gap = [12, 16],
    labelWidth
}: {
    children: ReactNode;
    cols?: number;
    gap?: number | [number, number];
    labelWidth?: number;
}) {
    return (
        <BaseInfo className="zh-grid" cols={cols} gap={gap} labelWidth={labelWidth}>
            {children}
        </BaseInfo>
    );
}

/** 旧 ZhBaseItem 的兼容入口；文件预览之外的布局由 zhihao-ui-react BaseItem 提供。 */
export function ZhBaseItem({
    children,
    fileId,
    label,
    labelWidth,
    rewriteFileName,
    span = 1,
    value,
    vertical = false
}: {
    children?: ReactNode;
    fileId?: number;
    label: ReactNode;
    labelWidth?: number;
    rewriteFileName?: string;
    span?: number;
    value?: ReactNode;
    vertical?: boolean;
}) {
    /** 对齐旧 BaseItem.file-id：点击展示名后查询文件真实地址并预览。 */
    const previewFile = async () => {
        if (!fileId) return;
        const file = await fileService.getFileById(fileId);
        window.open(file.path, "_blank");
    };
    const content = fileId ? (
        <Button className="zh-base-item__file" type="link" onClick={() => void previewFile()}>
            {rewriteFileName || "查看文件"}
        </Button>
    ) : (
        (children ?? value ?? "--")
    );
    return <BaseItem
        className={`zh-base-item${vertical ? " zh-base-item--vertical" : ""}`}
        infoDirection={vertical ? "vertical" : "horizontal"}
        label={label}
        labelWidth={labelWidth}
        span={span}
        valueNode={content}
    />;
}
